"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NetworkState;
(function (NetworkState) {
    NetworkState[NetworkState["LAN_CABLE_ATTACHED"] = 1] = "LAN_CABLE_ATTACHED";
    NetworkState[NetworkState["LAN_CABLE_DETACHED"] = 2] = "LAN_CABLE_DETACHED";
    NetworkState[NetworkState["LAN_CABLE_STATE_UNKNOWN"] = 3] = "LAN_CABLE_STATE_UNKNOWN";
    NetworkState[NetworkState["GATEWAY_CONNECTED"] = 4] = "GATEWAY_CONNECTED";
    NetworkState[NetworkState["GATEWAY_DISCONNECTED"] = 5] = "GATEWAY_DISCONNECTED";
    NetworkState[NetworkState["WIFI_MODULE_STATE_ATTACHED"] = 6] = "WIFI_MODULE_STATE_ATTACHED";
    NetworkState[NetworkState["WIFI_MODULE_STATE_DETACHED"] = 7] = "WIFI_MODULE_STATE_DETACHED";
    NetworkState[NetworkState["WIFI_MODULE_STATE_UNKNOWN"] = 8] = "WIFI_MODULE_STATE_UNKNOWN";
})(NetworkState = exports.NetworkState || (exports.NetworkState = {}));
var NetworkIpMode;
(function (NetworkIpMode) {
    NetworkIpMode[NetworkIpMode["NONE"] = 0] = "NONE";
    NetworkIpMode[NetworkIpMode["STATIC"] = 1] = "STATIC";
    NetworkIpMode[NetworkIpMode["DYNAMIC"] = 2] = "DYNAMIC";
    NetworkIpMode[NetworkIpMode["AUTO"] = 3] = "AUTO";
    NetworkIpMode[NetworkIpMode["FIXED"] = 4] = "FIXED";
    NetworkIpMode[NetworkIpMode["UNKNOWN"] = 5] = "UNKNOWN";
})(NetworkIpMode = exports.NetworkIpMode || (exports.NetworkIpMode = {}));
var NetworkActiveConnectionType;
(function (NetworkActiveConnectionType) {
    NetworkActiveConnectionType[NetworkActiveConnectionType["DISCONNECTED"] = 0] = "DISCONNECTED";
    NetworkActiveConnectionType[NetworkActiveConnectionType["WIFI"] = 1] = "WIFI";
    NetworkActiveConnectionType[NetworkActiveConnectionType["CELLULAR"] = 2] = "CELLULAR";
    NetworkActiveConnectionType[NetworkActiveConnectionType["ETHERNET"] = 3] = "ETHERNET";
})(NetworkActiveConnectionType = exports.NetworkActiveConnectionType || (exports.NetworkActiveConnectionType = {}));
var NetworkWiFiSecurityMode;
(function (NetworkWiFiSecurityMode) {
    NetworkWiFiSecurityMode[NetworkWiFiSecurityMode["WEP"] = 1] = "WEP";
    NetworkWiFiSecurityMode[NetworkWiFiSecurityMode["WPA_PSK"] = 2] = "WPA_PSK";
    NetworkWiFiSecurityMode[NetworkWiFiSecurityMode["WPA2_PSK"] = 3] = "WPA2_PSK";
    NetworkWiFiSecurityMode[NetworkWiFiSecurityMode["EAP"] = 4] = "EAP";
    NetworkWiFiSecurityMode[NetworkWiFiSecurityMode["NONE"] = 5] = "NONE";
    NetworkWiFiSecurityMode[NetworkWiFiSecurityMode["UNKNOWN"] = 6] = "UNKNOWN";
})(NetworkWiFiSecurityMode = exports.NetworkWiFiSecurityMode || (exports.NetworkWiFiSecurityMode = {}));
var NetworkWiFiEncryptionType;
(function (NetworkWiFiEncryptionType) {
    NetworkWiFiEncryptionType[NetworkWiFiEncryptionType["WEP"] = 1] = "WEP";
    NetworkWiFiEncryptionType[NetworkWiFiEncryptionType["TKIP"] = 2] = "TKIP";
    NetworkWiFiEncryptionType[NetworkWiFiEncryptionType["AES"] = 3] = "AES";
    NetworkWiFiEncryptionType[NetworkWiFiEncryptionType["TKIP_AES_MIXED"] = 4] = "TKIP_AES_MIXED";
    NetworkWiFiEncryptionType[NetworkWiFiEncryptionType["NONE"] = 5] = "NONE";
    NetworkWiFiEncryptionType[NetworkWiFiEncryptionType["UNKNOWN"] = 6] = "UNKNOWN";
})(NetworkWiFiEncryptionType = exports.NetworkWiFiEncryptionType || (exports.NetworkWiFiEncryptionType = {}));
var AvPlayPlayerState;
(function (AvPlayPlayerState) {
    AvPlayPlayerState["None"] = "NONE";
    AvPlayPlayerState["Idle"] = "IDLE";
    AvPlayPlayerState["Ready"] = "READY";
    AvPlayPlayerState["Playing"] = "PLAYING";
    AvPlayPlayerState["Paused"] = "PAUSED";
})(AvPlayPlayerState = exports.AvPlayPlayerState || (exports.AvPlayPlayerState = {}));
var AvPlayDisplayMode;
(function (AvPlayDisplayMode) {
    AvPlayDisplayMode["LetterBox"] = "PLAYER_DISPLAY_MODE_LETTER_BOX";
    AvPlayDisplayMode["FullScreen"] = "PLAYER_DISPLAY_MODE_FULL_SCREEN";
    AvPlayDisplayMode["AutoAspectRatio"] = "PLAYER_DISPLAY_MODE_AUTO_ASPECT_RATIO";
})(AvPlayDisplayMode = exports.AvPlayDisplayMode || (exports.AvPlayDisplayMode = {}));
var AvPlayBufferOption;
(function (AvPlayBufferOption) {
    AvPlayBufferOption["BufferForPlay"] = "PLAYER_BUFFER_FOR_PLAY";
    AvPlayBufferOption["BufferForResume"] = "PLAYER_BUFFER_FOR_RESUME";
})(AvPlayBufferOption = exports.AvPlayBufferOption || (exports.AvPlayBufferOption = {}));
var AvPlayBufferSizeUnit;
(function (AvPlayBufferSizeUnit) {
    AvPlayBufferSizeUnit["BufferSizeInByte"] = "PLAYER_BUFFER_SIZE_IN_BYTE";
    AvPlayBufferSizeUnit["BufferSizeInSecond"] = "PLAYER_BUFFER_SIZE_IN_SECOND";
})(AvPlayBufferSizeUnit = exports.AvPlayBufferSizeUnit || (exports.AvPlayBufferSizeUnit = {}));
var AvPlayStreamingPropertyType;
(function (AvPlayStreamingPropertyType) {
    AvPlayStreamingPropertyType["Cookie"] = "COOKIE";
    AvPlayStreamingPropertyType["UserAgent"] = "USER_AGENT";
    AvPlayStreamingPropertyType["PrebufferMode"] = "PREBUFFER_MODE";
    AvPlayStreamingPropertyType["AdaptiveInfo"] = "ADAPTIVE_INFO";
    AvPlayStreamingPropertyType["SetMode4k"] = "SET_MODE_4K";
    AvPlayStreamingPropertyType["PropertyHdAudio"] = "PROPERTY_HD_AUDIO";
    AvPlayStreamingPropertyType["ListenSparseTrack"] = "LISTEN_SPARSE_TRACK";
    AvPlayStreamingPropertyType["IsLive"] = "IS_LIVE";
    AvPlayStreamingPropertyType["AvailableBitrate"] = "AVAILABLE_BITRATE";
    AvPlayStreamingPropertyType["GetLiveDuration"] = "GET_LIVE_DURATION";
    AvPlayStreamingPropertyType["CurrentBandwidth"] = "CURRENT_BANDWIDTH";
    AvPlayStreamingPropertyType["Widevine"] = "WIDEVINE";
    AvPlayStreamingPropertyType["SetVr360Mode"] = "SET_VR360_MODE";
    AvPlayStreamingPropertyType["GetAbsoluteServerTime"] = "GET_ABSOLUTE_SERVER_TIME";
    AvPlayStreamingPropertyType["GetServerTimeScale"] = "GET_SERVER_TIME_SCALE";
})(AvPlayStreamingPropertyType = exports.AvPlayStreamingPropertyType || (exports.AvPlayStreamingPropertyType = {}));
var AvPlayDrmType;
(function (AvPlayDrmType) {
    AvPlayDrmType["Playready"] = "PLAYREADY";
    AvPlayDrmType["Verimatrix"] = "VERIMATRIX";
    AvPlayDrmType["Widevine"] = "WIDEVINE_CDM";
})(AvPlayDrmType = exports.AvPlayDrmType || (exports.AvPlayDrmType = {}));
var AvPlayDrmOperation;
(function (AvPlayDrmOperation) {
    AvPlayDrmOperation["SetProperties"] = "SetProperties";
    AvPlayDrmOperation["InstallLicense"] = "InstallLicense";
    AvPlayDrmOperation["ProcessInitiator"] = "ProcessInitiator";
    AvPlayDrmOperation["GetUid"] = "GetUID";
    AvPlayDrmOperation["Initialize"] = "Initialize";
    AvPlayDrmOperation["Finalize"] = "Finalize";
    AvPlayDrmOperation["WidevineLicenseData"] = "widevine_license_data";
    AvPlayDrmOperation["WidevineAppSession"] = "widevine_app_session";
    AvPlayDrmOperation["WidevineDataType"] = "widevine_data_type";
})(AvPlayDrmOperation = exports.AvPlayDrmOperation || (exports.AvPlayDrmOperation = {}));
var AvPlayStreamType;
(function (AvPlayStreamType) {
    AvPlayStreamType["Video"] = "VIDEO";
    AvPlayStreamType["Audio"] = "AUDIO";
    AvPlayStreamType["Text"] = "TEXT";
})(AvPlayStreamType = exports.AvPlayStreamType || (exports.AvPlayStreamType = {}));
var AvPlayError;
(function (AvPlayError) {
    AvPlayError["None"] = "PLAYER_ERROR_NONE";
    AvPlayError["InvalidParameter"] = "PLAYER_ERROR_INVALID_PARAMETER";
    AvPlayError["NoSuchFile"] = "PLAYER_ERROR_NO_SUCH_FILE";
    AvPlayError["InvalidOperation"] = "PLAYER_ERROR_INVALID_OPERATION";
    AvPlayError["SeekFailed"] = "PLAYER_ERROR_SEEK_FAILED";
    AvPlayError["InvalidState"] = "PLAYER_ERROR_INVALID_STATE";
    AvPlayError["NotSupportedFile"] = "PLAYER_ERROR_NOT_SUPPORTED_FILE";
    AvPlayError["NotSupportedFormat"] = "NOT_SUPPORTED_FORMAT";
    AvPlayError["InvalidUri"] = "PLAYER_ERROR_INVALID_URI";
    AvPlayError["ConnectionFailed"] = "PLAYER_ERROR_CONNECTION_FAILED";
    AvPlayError["Generic"] = "PLAYER_ERROR_GENEREIC";
})(AvPlayError = exports.AvPlayError || (exports.AvPlayError = {}));
var AvPlayEvent;
(function (AvPlayEvent) {
    AvPlayEvent["MsgNone"] = "PLAYER_MSG_NONE";
    AvPlayEvent["MsgResolutionChanged"] = "PLAYER_MSG_RESOLUTION_CHANGED";
    AvPlayEvent["MsgBitrateChange"] = "PLAYER_MSG_BITRATE_CHANGE";
    AvPlayEvent["MsgFragmentInfo"] = "PLAYER_MSG_FRAGMENT_INFO";
    AvPlayEvent["SparseTrackDetect"] = "PLAYER_SPARSE_TRACK_DETECT";
    AvPlayEvent["StreamingEvent"] = "PLAYER_STREAMING_EVENT";
    AvPlayEvent["MsgHttpErrorCode"] = "PLAYER_MSG_HTTP_ERROR_CODE";
    AvPlayEvent["MsgDrmChallengeData"] = "PLAYER_MSG_DRM_CHALLENGE_DATA";
})(AvPlayEvent = exports.AvPlayEvent || (exports.AvPlayEvent = {}));
